import React from "react";

export default function ActivationCode({ code, seconds, message }: { code: string; seconds: number; message: string }) {
  const minutes = Math.floor(seconds / 60);
  const countdown = `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
  return <>
    {seconds > 0 && <div className="terminal-code clickshare-code">{code}</div>}
    {seconds > 0 && <p className="terminal-muted">Code expires in {countdown}</p>}
    <p role="status">{message || "Waiting for activation…"}</p>
  </>;
}
